import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { TournamentService } from '../../services/tournament.service';
import { AuthenticationService } from '../../services/authentication.service';
import { MyTournament, TournamentStatus } from '../../model/tournament';

@Component({
  selector: 'app-my-tournaments',
  standalone: true,
  imports: [CommonModule, RouterModule, LucideAngularModule],
  templateUrl: './my-tournaments.component.html',
  styleUrl: './my-tournaments.component.css',
})
export class MyTournamentsComponent implements OnInit {
  loading = true;
  upcoming: MyTournament[] = [];
  active: MyTournament[] = [];
  completed: MyTournament[] = [];

  constructor(
    private tournamentService: TournamentService,
    private auth: AuthenticationService,
    private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.auth.waitForInitialization();
    this.tournamentService.getMine().subscribe({
      next: rows => { this.group(rows); this.loading = false; },
      error: () => { this.loading = false; },
    });
  }

  private group(rows: MyTournament[]): void {
    this.upcoming = rows.filter(r => r.tournament.status === TournamentStatus.Open || r.tournament.status === TournamentStatus.ReadyToDraw);
    this.active = rows.filter(r => r.tournament.status === TournamentStatus.Drawn);
    this.completed = rows.filter(r => r.tournament.status === TournamentStatus.Completed);
  }

  get isEmpty(): boolean {
    return this.upcoming.length === 0 && this.active.length === 0 && this.completed.length === 0;
  }

  goToDetail(id: number): void {
    this.router.navigate(['/tournaments', id]);
  }
}
